import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { useLocation } from "react-router-dom";
import { connect, useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  iframeContainer: {
    position: "fixed",
    top: "60px",
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#dde3eb",
  },
  iframe: {
    paddingLeft: "60px",
    width: "100%",
    height: "100%",
    border: "none",
  },
}));

const PowerAppEmbed = () => {
  const allURLs = {
    STCP_RDP_URL:
      "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/978db457-ccac-4b27-b49e-84bc0bda780a?tenantId=12a3af23-a769-4654-847f-958f3d479f4a",
    LTCP_RDP_URL:
      "https://apps.powerapps.com/play/e/fca7c72b-8717-ee1f-8336-57fbdee7c10d/a/45993436-63f6-4a11-8600-a86ec0347fbb?tenantId=12a3af23-a769-4654-847f-958f3d479f4a&hint=dd58c81a-8d7b-4113-bc7f-240235c99f89&sourcetime=1750315481608",
    POOS_URL:
      "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/11ae53f0-06d5-49f0-8804-604e9f84b262?tenantId=12a3af23-a769-4654-847f-958f3d479f4a&hint=16ff92af-38ab-4806-be0e-3e4bf8a443f4&sourcetime=1754317155640&source=portal",
    DEFAULT_URL:
      "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/c37d965e-72a6-4e3a-8e6e-56fa4a257869?tenantId=12a3af23-a769-4654-847f-958f3d479f4a",
    FF_URL:
      "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/3306ad7a-3063-4bdc-93fc-28df2425c87a?tenantId=12a3af23-a769-4654-847f-958f3d479f4a&hint=c507aac4-e52f-4832-ac56-fd31b2221d28&sourcetime=1738925044208&source=portal#",
    FGS_URL:
      "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/0b5ab36d-8c12-4f41-b5c6-6973f65bd9e2?tenantId=12a3af23-a769-4654-847f-958f3d479f4a#",
    DC_UAT_URL:
      "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/bbc21fb3-51f6-4f44-a768-2565c7b59e99?tenantId=12a3af23-a769-4654-847f-958f3d479f4a&hint=63cb52b0-2ef4-4cc9-9e72-c8b62180b4c9&sourcetime=1760010671731&source=portal",
    PL_UAT_URL:
      "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/01d5b04e-0ce5-438b-a02b-04d061428426?tenantId=12a3af23-a769-4654-847f-958f3d479f4a&hint=58dd7bf8-e2d2-4702-8bea-cd0e29e97c10&sourcetime=1760010671720&source=portal",
    RR: "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/7ce1ee20-27db-425b-8537-c54ef52db074?tenantId=12a3af23-a769-4654-847f-958f3d479f4a",
    NPS: "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/2747aeb9-7568-4671-84c4-3b98a56d22db?tenantId=12a3af23-a769-4654-847f-958f3d479f4a",
    CONFIG:
      "https://apps.powerapps.com/play/e/fc458343-c2e0-e167-99cd-73002bd5610a/a/2cad3c10-e718-438c-a496-6da0c9b45f63?tenantId=12a3af23-a769-4654-847f-958f3d479f4a&hint=8f26df7b-9e46-4284-b10e-4cdcf59c90b6&sourcetime=1760010671722&source=portal",
  };
  const [url, setUrl] = useState();
  const classes = useStyles();
  const location = window.location.pathname;

  useEffect(() => {
    if (location === "/action/STCP-RDP") {
      setUrl(allURLs["STCP_RDP_URL"]);
    } else if (location === "/action/LTCP-RDP") {
      setUrl(allURLs["LTCP_RDP_URL"]);
    } else if (location === "/action/poos") {
      setUrl(allURLs["POOS_URL"]);
    } else if (location === "/action/ff") {
      setUrl(allURLs["FF_URL"]);
    } else if (location === "/action/fgs") {
      setUrl(allURLs["FGS_URL"]);
    } else if (location === "/action/rr") {
      setUrl(allURLs["RR"]);
    } else if (location === "/action/DC") {
      setUrl(allURLs["DC_UAT_URL"]);
    } else if (location === "/action/3PL") {
      setUrl(allURLs["PL_UAT_URL"]);
    } else if (location === "/action/nps") {
      setUrl(allURLs["NPS"]);
    } else if (location === "/action/CONFIG") {
      setUrl(allURLs["CONFIG"]);
    } else {
      setUrl(allURLs["DEFAULT_URL"]);
    }
  }, [location]);

  return (
    <div className={classes.iframeContainer}>
      <iframe
        title="PowerApp"
        src={url}
        className={classes.iframe}
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default PowerAppEmbed;
